import { useState } from "react";
import { Spinner, Modal } from "@/components/kit";
import { useAdminQuery } from "@/hooks/queries";
import { AdminHeader, AdminTable, StatCard } from "@/pages/admin/AdminLayout";

function Detail({ id, onClose }) {
  const q = useAdminQuery(`/admin/goals/users/${id}`, { enabled: !!id });
  const d = q.data;
  const entries = d ? Object.entries(d).filter(([, v]) => v !== null && typeof v !== "object") : [];
  const lists = d ? Object.entries(d).filter(([, v]) => Array.isArray(v)) : [];
  return (
    <Modal open={!!id} onClose={onClose} title={d?.name || d?.user?.name || "User goals"} wide testid="admin-goal-detail">
      {!d ? <Spinner /> : (
        <div className="space-y-4 text-[14px]">
          <div className="grid grid-cols-2 gap-2">{entries.map(([k, v]) => <div key={k} className="rounded-xl bg-[#F8FAFC] px-3 py-2"><p className="text-[12px] text-[#64748B]">{k}</p><p className="font-bold">{String(v)}</p></div>)}</div>
          {lists.map(([k, arr]) => (
            <div key={k}><p className="font-bold mb-1">{k}</p>{arr.slice(0, 30).map((x, i) => <p key={i} className="py-1 border-b border-[#F1F5F9]">{typeof x === "object" ? [x.title, x.date, x.completedAt].filter(Boolean).join(" · ") || JSON.stringify(x) : String(x)}</p>)}{!arr.length && <p className="text-[#64748B]">None</p>}</div>
          ))}
        </div>
      )}
    </Modal>
  );
}

export default function AdminGoals() {
  const o = useAdminQuery("/admin/goals/overview").data;
  const users = useAdminQuery("/admin/goals/users");
  const [sel, setSel] = useState(null);
  const rate = o?.dailyCompletionRate;
  return (
    <>
      <AdminHeader title="Goals" sub="Networking goals and streak engagement." />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <StatCard label="Users with goals" value={o ? `${o.totalUsersWithGoals} / ${o.totalUsers}` : null} testid="goals-users" />
        <StatCard label="Completed today" value={o?.completedToday} accent="#059669" testid="goals-completed-today" />
        <StatCard label="Average streak" value={o ? Number(o.averageStreak).toFixed(1) : null} accent="#EA580C" testid="goals-avg-streak" />
        <StatCard label="Daily completion" value={rate != null ? `${Math.round(rate <= 1 ? rate * 100 : rate)}%` : null} accent="#7C3AED" testid="goals-rate" />
      </div>
      {users.isLoading ? <Spinner /> : (
        <AdminTable testid="admin-goals-users" rows={users.data ?? []} onRow={(r) => setSel(r.id)} cols={[
          { label: "Name", render: (r) => <b>{r.name}</b> }, { label: "Email", k: "email" }, { label: "Current streak", k: "currentStreak" }, { label: "Longest", k: "longestStreak" }, { label: "Completed", k: "completedTotal" },
        ]} />
      )}
      <Detail id={sel} onClose={() => setSel(null)} />
    </>
  );
}
